import { Component, OnDestroy } from '@angular/core';
import { map, shareReplay } from 'rxjs/operators';

import { RecentFileComponent } from './recent-file/recent-file.component';
import { ItemTabComponent } from '../../_basic/tab-playlist-item.component';
import { PlaylistItemType } from '../../../core/models/enums/playlist-item-type.enum';
import { PlaylistItemDTO } from '../../../core/models/view-models/playlist-item-models/playlist-item-dto.model';
import { AppConstants } from '../../../app.constants';
import { PlaylistItemChangeSourceModel } from '../../../core/models/view-models/playlist-item-models/playlist-item-change-source-model';

@Component({
  selector: 'tab-recent-files',
  templateUrl: './tab-recent-files.component.html',
  styleUrls: [
    './tab-recent-files.component.scss',
    '../../modal-playlist-item/playlist-item-dialog.component.scss'
  ]
})
export class TabRecentFilesComponent extends ItemTabComponent implements OnDestroy {
  public checkedPlaylists: number = 0;

  constructor() {
    super();
    this.recentFiles$ = this.filesService.getRecentFiles().pipe(
      map(files => files.map(file =>
        file.Duration ?
          ({...file, Duration: this.filesService.roundDuration(file.Duration)}) :
          file)),
      shareReplay(1)
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  submit() {
    this.playlistItem.IsLocal = false;
    const playlistItems: PlaylistItemDTO[] = [];
    const selectedRecentFiles: RecentFileComponent[] = this.recentFilesComponents.filter((item: RecentFileComponent) => {
      return item.IsChecked && !!item.playlistItem;
    });

    if (selectedRecentFiles && selectedRecentFiles.length) {
      selectedRecentFiles.forEach((x: RecentFileComponent, index: number) => {
        if (x.IsChecked && x.playlistItem) {
          x.playlistItem.PlaylistItemTitle = x.playlistItem.PlaylistItemLinks.length > 1 ?
            x.playlistItemName || AppConstants.MULTIPLE_ITEMS_TITLE :
            x.playlistItem.PlaylistItemTitle;

          x.playlistItem.Launcher = x.selectedLauncher;
          x.playlistItem.PlaylistItemType = PlaylistItemType.RecentFile;
          // Here we allow changing existing item and ONLY the first one if the item already had a title (already existed)
          x.playlistItem.isToChangeExisted = !!this.playlistItem.PlaylistItemTitle && index === 0;
          playlistItems.push(x.playlistItem);
        }
      });

      if (playlistItems.length) {
        super.saveChanges(playlistItems);
        this.recentFilesComponents.forEach((x: RecentFileComponent) => x.clear());
      }
    }
  }

  calculateSelectedPlaylists(amount: number) {
    this.checkedPlaylists += amount;
  }

  onSetDurationForAllItems(duration: string): void {
    this.recentFilesComponents.forEach(recentFile => {
      if (recentFile.IsChecked) {
        recentFile.playlistItem.Duration = duration;
        recentFile.playlistItem.useExactDuration = false;
        recentFile.showApplyDurationOption = false;
      }
    });
  }

  onChangeSourceField(data: PlaylistItemChangeSourceModel): void {
    this.onChangeField(data.item, data.sourceId);
  }

  onChangeSourceData(data: PlaylistItemChangeSourceModel): void {
    this.onSourceChanged(data.event, data.sourceId, data.item);
  }

  onChangeMode(data: PlaylistItemChangeSourceModel): void {
    this.onChangeMCLMode(data.item, data.mclMode);
  }

  onDetermineDuration(item: PlaylistItemDTO): void {
    this.calculateAndSetDuration(item);
  }
}
